import { number, string } from 'prop-types';
import React, { useEffect, memo } from 'react';

const ResultCount = props => {
    const { controller, queryState, setQueryState } = props;
    const onStateChange = () => {
        const state = controller.state;
        setQueryState(state);
    };

    useEffect(() => {
        controller.subscribe(onStateChange);
    }, []);
    return (
        <div tabIndex='0'>{queryState && `Showing ${queryState.firstResult}-${queryState.lastResult} of ${queryState.total}`}</div>
    );
};

ResultCount.propsType = {
    totalCount: number,
    showingText: string
};

ResultCount.defaultProps = {
    showingText: 'Showing'
};

export default memo(ResultCount);
